module.exports = __webpack_public_path__ + "img/empty.9ec22bb6.svg";